export default {
  INGREDIENTS: 'ingredients',
  METHOD: 'method',
};
